var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GlobalSidebarContainer',{staticClass:"hidden-sm-and-down"},[_c('div',{staticClass:"sidebar-items"},_vm._l((5),function(n){return _c('BaseSkeleton',{key:n,staticClass:"sidebar-item"})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }